<template>
    <div>
        <v-container class="fill-height" fluid>
            <v-tabs class=""  v-model="tab">
                <v-tabs-slider></v-tabs-slider>
                <v-tab :href="`#tab-${index}`" class="text-capitalize" :key="index" v-for="(tab,index) in tabs">{{tab.name}}</v-tab>
                <v-tab-item :key="index" :value="`tab-${index}`" v-for="(tab,index) in tabs">
                    <component :is="tab.component"/>
                </v-tab-item>
            </v-tabs>
        </v-container>
    </div>
</template>

<script>
import ServiceCategories from "./ServiceCategories";
import ServiceProviders from "./ServiceProviders";

export default {
name: 'Services',
    components: {ServiceProviders, ServiceCategories},
    data () {
    return {
        tab: 'tab-0',
        tabs: [
            {name: 'Service Categories', component: ServiceCategories },
            {name: 'Service Providers', component: ServiceProviders }
        ],
    }
}
}
</script>

<style scoped>
/deep/.theme--light.v-tabs>.v-tabs-bar{
    border-bottom: 1px solid #BEBEBE;
}
</style>